import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  BoxProps,
  Container,
  Flex,
  Heading,
} from '@chakra-ui/react';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CMS } from '@waitroom/models';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import CmsButton from '../../../../cms/components/Button/CmsButton';
import { isLinkDefined } from '../../../../cms/utils/sanity';
import { Icon } from '../../Icon/Icon';
import Markdown from '../../Markdown/Markdown';

const Faq = ({ items, heading, link, ...rest }: CMS.Faq & BoxProps): ReactElement | null => {
  const { t } = useTranslation();
  const hasLink = isLinkDefined(link);

  if (!items?.length) return null;
  return (
    <Box {...rest}>
      <Container maxW="container.2xl">
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          gap={{ base: 8, lg: 20, xl: 24 }}
          alignItems="flex-start"
        >
          <Heading flexShrink={0} as="h2" size="5xl" lineHeight="shorter" px={0}>
            {heading?.length ? heading : t('faq.title')}
          </Heading>
          <Box flexGrow={1} w="full">
            <Accordion allowToggle>
              {items.map((item, i) => (
                <AccordionItem key={i}>
                  <h4>
                    <AccordionButton
                      w="full"
                      fontWeight="800"
                      px={0}
                      py={3}
                      textAlign="left"
                      justifyContent="flex-start"
                      mr={2}
                    >
                      {item.question}
                      <AccordionIcon ml="auto" boxSize="34px" color="gray.500" />
                    </AccordionButton>
                  </h4>
                  <AccordionPanel px={0} pb={4}>
                    <Markdown>{item.answer}</Markdown>
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
            {hasLink && (
              <Box mt={6}>
                <CmsButton data={link} rightIcon={<Icon icon={faArrowRight} ml={1} />}>
                  {link.text}
                </CmsButton>
              </Box>
            )}
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};
export default Faq;
